/**
 * Client fuer den vereinheitlichten Bestell-Zeitstrahl (Auftrag "Bestellungs-Aenderungshistorie",
 * Task 11 - Frontend-Gegenstueck zu Task 10s `GET /api/orders/:id/history`).
 *
 * Die globale Aktivitaetenliste der Uebersichtskachel (`GET /api/activities/recent`, `.../event-types`)
 * hatte hier ebenfalls ihre Aufrufer; sie sind mit der Kachel entfallen. Die Seite "Aktivitaeten"
 * liest ueber `api/aktivitaeten.ts`.
 *
 * `HistorienEintrag` ist die woertliche Spiegelung von `backend/src/domaene/historie.ts` -
 * EIGENSTAENDIG hier notiert statt importiert, wie es auch die uebrigen `api/*.ts`-Module halten
 * (kein gemeinsames Typpaket zwischen Backend und Frontend in diesem Projekt).
 *
 * ================= `summary` ist im Typ `string`, LAUFZEIT-nullbar =================
 *
 * Zwei dokumentierte Luecken der Backend-Instrumentierung (`domaene/historie.ts`,
 * `ladeHistorieFuerBestellung`): fuer Statuswechsel ohne Notiz (`order_history.note`) liefert die
 * SQL-Abfrage `oh.note AS summary` ein rohes SQL-`NULL`, das JSON als `null` ueberliefert - der Typ
 * hier bleibt trotzdem `string` (woertliche Spiegelung des Backend-Interfaces, nicht dessen
 * Laufzeitrealitaet). Jeder Verbraucher (hier: `HistoryTab.tsx`) muss `summary == null` selbst
 * abfangen, statt sich auf den deklarierten Typ zu verlassen.
 */
import { anfrage } from "./basis.ts";

export interface HistorienEintrag {
  ts: string;
  aktor: string | null;
  feld: string | null;
  altWert: string | null;
  neuWert: string | null;
  quelle: string;
  kategorie: "status" | "audit" | "dsv_termin" | "ek_preis";
  summary: string;
  betroffene?: Array<{ name?: string; [k: string]: unknown }>;
}

/** Der vollstaendige Zeitstrahl EINER Bestellung, absteigend sortiert (`GET .../history`). */
export function historieLaden(orderId: string, signal?: AbortSignal): Promise<HistorienEintrag[]> {
  return anfrage<HistorienEintrag[]>(
    `/api/orders/${encodeURIComponent(orderId)}/history`,
    { signal },
  );
}
